import { nextAt, nextMonday } from '@/lib/timePresets';
import { TimeMenu } from './TimeMenu';

/**
 * Send-later options.
 *
 * The presets and the picker itself live in `TimeMenu`, which reminders use
 * too — deciding when something should happen is the same interaction whether
 * the thing is a message going out or a nudge coming back.
 */
export function ScheduleSendMenu({
  onSchedule,
  onClose,
  className,
}: {
  onSchedule: (sendAt: Date) => void;
  onClose: () => void;
  className?: string;
}) {
  return (
    <TimeMenu
      title="Send later"
      inputId="schedule-custom"
      className={className}
      onClose={onClose}
      onPick={onSchedule}
      presets={[
        { label: 'In 30 minutes', at: new Date(Date.now() + 30 * 60_000) },
        { label: 'In 2 hours', at: new Date(Date.now() + 2 * 60 * 60_000) },
        { label: 'Tomorrow, 9am', at: nextAt(9, 1) },
        { label: 'Monday, 9am', at: nextMonday(9) },
      ]}
    />
  );
}
